"use client";

import {
  Facebook,
  Instagram,
  Youtube,
  Linkedin,
  MessageCircle,
  PhoneCall,
} from "lucide-react";

const SocialSidebar = () => {
  const icons = [
    { icon: <Facebook strokeWidth={1.5} />, label: "Facebook", href: "https://www.facebook.com/people/Design-Nook/61558737094947/" },
    { icon: <Instagram strokeWidth={1.5} />, label: "Instagram", href:"https://www.instagram.com/design_nook.interiors/" },
    { icon: <Youtube strokeWidth={1.5} />, label: "YouTube", href: "https://www.youtube.com/@designook.interiors" },
    { icon: <Linkedin strokeWidth={1.5} />, label: "LinkedIn", href: "https://in.linkedin.com/in/design-nook-interior-design-studio-092250352" },
    // { icon: <PhoneCall strokeWidth={1.5} />, label: "WhatsApp", href: "#" },
    { icon: <MessageCircle strokeWidth={1.5} />, label: "Message", href:"https://wa.me/7017208147" },
  ];

  return (
    <div className="fixed -bottom-20 right-4 -translate-y-1/2 z-50 hidden md:flex flex-col items-center space-y-3">
      {icons.map(({ icon, label, href }, idx) => (
        <a
          key={idx}
          href={href}
          aria-label={label}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-[#A65D5D] border border-white hover:scale-110 transition-transform duration-300"
        >
          <span className="text-white">{icon}</span>
        </a>
      ))}
    </div>
  );
};

export default SocialSidebar;
